module.exports = __webpack_public_path__ + "img/icon_loyalty_point.9d122de1.svg";